import ApiClient from './apiClient'
import {
  RequestDeleteTaskLabeling,
  RequestDeleteTaskLabelMasterSetting,
  RequestDeleteTaskLabelSettingLabelGroup,
  RequestDeleteTaskManual,
  RequestDeleteTaskTargetServiceSetting,
  RequestGetTaskExportDetail,
  RequestGetTaskLabeling,
  RequestGetTaskLabelingStatus,
  RequestGetTaskLabelSetting,
  RequestGetTaskLabelSettingDetail,
  RequestGetTaskReportLabelGroup,
  RequestGetTaskReportLabelGroupDetail,
  RequestGetTaskReportLabelGroupDetailMax,
  RequestGetTaskReportLabelGroupDetailSummary,
  RequestGetTaskSearch,
  RequestPostTaskServiceRequest,
  RequestPatchTaskMemberCosts,
  RequestPatchTaskLabeling,
  RequestPatchTaskLabelMasterSetting,
  RequestPatchTaskLabelSettingLabelGroup,
  RequestPatchTaskLabelSettingTeamLabelRelation,
  RequestPatchTaskPermission,
  RequestPatchTaskReportLabelGroupDetailSummary,
  RequestPostTaskExportDetail,
  RequestPostTaskLabeling,
  RequestPostTaskLabelMasterSetting,
  RequestPostTaskLabelSettingLabelGroup,
  RequestPostTaskManual,
  RequestPostTaskTargetServiceSetting,
  ResponseGetTaskMemberCosts,
  ResponseGetTaskExportDetail,
  ResponseGetTaskExportList,
  ResponseGetTaskLabeling,
  ResponseGetTaskLabelingStatus,
  ResponseGetTaskLabelMasterSetting,
  ResponseGetTaskLabelSetting,
  ResponseGetTaskLabelSettingDetail,
  ResponseGetTaskLabelSettingNewDetail,
  ResponseGetTaskCandidateServices,
  ResponseGetTaskPermission,
  ResponseGetTaskReportLabelGroup,
  ResponseGetTaskReportLabelGroupDetail,
  ResponseGetTaskReportLabelGroupDetailMax,
  ResponseGetTaskReportLabelGroupDetailSummary,
  ResponseGetTaskSearch,
  ResponseGetTaskSearchNew,
  ResponseGetTaskTargetServiceSetting,
  ResponsePostTaskLabelMasterSetting,
  ResponsePostTaskLabelSettingLabelGroup,
  ResponsePostTaskManual,
  ResponsePostTaskTargetServiceSetting,
  RequestPostTaskSeparate,
  ResponsePostTaskSeparate,
  RequestDeleteTaskSeparate,
  ResponseDeleteTaskSeparate,
  ResponseGetTaskThresholdSetting,
  RequestPatchTaskThresholdSetting,
  RequestGetTaskReportTeam,
  ResponseGetTaskReportTeam,
  RequestGetTaskReportMember,
  ResponseGetTaskReportMember,
  RequestDeleteTaskProjectTemplateSetting,
  RequestGetTaskProjectTemplateSetting,
  RequestGetTaskProjectTemplateSettingDetail,
  RequestPatchTaskProjectTemplateSetting,
  RequestPostTaskProjectTemplateSetting,
  ResponseGetTaskProjectTemplateSetting,
  ResponseGetTaskProjectTemplateSettingDetail,
  ResponsePostTaskProjectTemplateSetting,
  ResponsePostTaskMemberCosts,
  ResponsePatchTaskMemberCosts,
  RequestPostTaskMemberCosts,
  ResponseGetTaskApprovalGroup,
  RequestPostTaskApprovalGroup,
  ResponsePostTaskApprovalGroup,
  RequestPatchTaskApprovalGroup,
  RequestDeleteTaskApprovalGroup,
  RequestGetTaskApprovalApplication,
  RequestGetTaskApprovalApplicationDetail,
  RequestPostTaskApprovalApplication,
  ResponseGetTaskApprovalApplication,
  ResponseGetTaskApprovalApplicationDetail,
  ResponseDeleteTaskManual,
  RequestDeleteTaskLabelGroupCategory,
  RequestPatchTaskLabelGroupCategory,
  RequestPostTaskLabelGroupCategory,
  ResponseGetTaskLabelGroupCategory,
  ResponsePostTaskLabelGroupCategory,
  RequestGetTaskReportLabelGroupCategory,
  ResponseGetTaskReportLabelGroupCategory,
  RequestGetTaskReportLabelGroupCategoryDetail,
  ResponseGetTaskReportLabelGroupCategoryDetail,
  RequestGetTaskReportLabelGroupCategoryDetailMax,
  ResponseGetTaskReportLabelGroupCategoryDetailMax,
  RequestGetTaskReportLabelGroupCategoryDetailSummary,
  ResponseGetTaskReportLabelGroupCategoryDetailSummary,
  ResponsePostTaskLabelGroupImport,
  ResponseGetTaskGanttChartList,
  RequestGetTaskGanttChart,
  ResponseGetTaskGanttChart,
  RequestGetTaskGanttChartDetail,
  ResponseGetTaskGanttChartDetail,
  RequestPatchTaskLabel,
  RequestPatchTaskLabelMember,
  ResponseGetTaskOverwriteBreakTimeSetting,
  RequestPatchTaskOverwriteBreakTimeSetting,
  ResponseGetTaskCustomSearchNew,
  RequestGetTaskCustomSearch,
  ResponseGetTaskCustomSearch,
  RequestPostTaskExcludeAutoLabelingTask,
  RequestDeleteTaskExcludeAutoLabelingTask,
  ResponsePostTaskExcludeAutoLabelingTask,
  RequestPostTaskLabelMasterImport,
  ResponsePostTaskLabelMasterImport,
  ResponseGetTaskLabelGroupOrder,
  RequestPatchTaskLabelGroupOrder,
  ResponseGetTaskLearningScopeSetting,
  RequestPatchTaskLearningScopeSetting,
  ResponseGetTaskLabelingTargetModeSetting,
  RequestPatchTaskLabelingTargetModeSetting,
  ResponseGetTaskBulkLabelingNew,
  ResponseGetTaskBulkLabeling,
  RequestGetTaskBulkLabeling,
  RequestPostTaskBulkLabeling,
  RequestDeleteTaskBulkLabeling,
  RequestGetTaskApprovalApplicationList,
  ResponseGetTaskApprovalApplicationList,
  RequestGetTaskNotWorkingRange,
  RequestPatchTaskNotWorkingRange,
  ResponseGetTaskNotWorkingRange,
  RequestGetTaskRecentlyUsedLabelGroup,
  RequestGetTaskSearchLabelGroup,
  ResponseGetTaskRecentlyUsedLabelGroup,
  ResponseGetTaskSearchLabelGroup,
  RequestGetTaskLabelGroupCategoryLabelGroup,
  ResponseGetTaskLabelGroupCategoryLabelGroup,
  RequestGetTaskViewableLabelGroup,
  ResponseGetTaskViewableLabelGroup,
  RequestGetTaskViewableLabelGroupDetail,
  ResponseGetTaskViewableLabelGroupDetail,
  RequestGetTaskViewableLabelGroupMember,
  ResponseGetTaskViewableLabelGroupMember,
  RequestGetTaskViewableLabelGroupTeam,
  ResponseGetTaskViewableLabelGroupTeam,
  RequestGetTaskLabelMasterSetting,
  RequestGetTaskLabelGroupSummary,
  ResponseGetTaskLabelGroupSummary,
  RequestGetTaskReportLabelGroupDetailYearlySummary,
  ResponseGetTaskReportLabelGroupDetailYearlySummary,
  RequestGetTaskReportLabelGroupCategoryDetailYearlySummary,
  ResponseGetTaskReportLabelGroupCategoryDetailYearlySummary,
  ResponseGetTaskCreateTaskByUrlSetting,
  RequestPatchTaskCreateTaskByUrlSetting,
  ResponseGetTaskCreateManualTaskZoneSetting,
  RequestPatchTaskCreateManualTaskZoneSetting,
  ResponseGetTaskDisableTaskCreationSetting,
  RequestPatchTaskDisableTaskCreationSetting,
  ResponseGetTaskOnlineMeetingSetting,
  RequestPatchTaskOnlineMeetingSetting,
  RequestGetTaskLabelingConditions,
  ResponseGetTaskLabelingConditions,
  RequestGetTaskLabelingConditionNew,
  ResponseGetTaskLabelingConditionNew,
  RequestPostTaskLabelingCondition,
  ResponsePostTaskLabelingCondition,
  RequestGetTaskMemberLabelingConditions,
  ResponseGetTaskMemberLabelingConditions,
  RequestGetTaskMemberLabelingConditionNew,
  ResponseGetTaskMemberLabelingConditionNew,
  RequestPostTaskMemberLabelingCondition,
  ResponsePostTaskMemberLabelingCondition,
  RequestPatchTaskLabelingCondition,
  ResponsePatchTaskLabelingCondition,
  RequestPatchTaskMemberLabelingCondition,
  ResponsePatchTaskMemberLabelingCondition,
  RequestDeleteTaskLabelingCondition,
  RequestDeleteTaskMemberLabelingCondition,
  ResponseGetTaskCompanyServiceGroup,
  ResponseGetTaskCompanyServiceGroupDetail,
  RequestGetTaskCompanyServiceGroupDetail,
  RequestPostTaskCompanyServiceGroup,
  RequestPatchTaskCompanyServiceGroup,
  ResponsePostTaskCompanyServiceGroup,
  RequestGetTaskGanttChartList,
} from '../types/task'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabeling = async (params: RequestGetTaskLabeling): Promise<any> => ApiClient.get(
  '/api/task/labeling',
  (result: ResponseGetTaskLabeling) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskLabeling = async (params: RequestPostTaskLabeling): Promise<any> => ApiClient.post(
  '/api/task/labeling',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabeling = async (params: RequestPatchTaskLabeling): Promise<any> => ApiClient.patch(
  '/api/task/labeling',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskLabeling = async (params: RequestDeleteTaskLabeling): Promise<any> => ApiClient.delete(
  '/api/task/labeling',
  () => {
    // do nothing
  },
  { data: params },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskManual = async (params: RequestPostTaskManual): Promise<any> => ApiClient.post(
  '/api/task/manual_tasks',
  (result: ResponsePostTaskManual) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskManual = async (params: RequestDeleteTaskManual): Promise<any> => ApiClient.delete(
  `/api/task/manual_tasks/${params.id}`,
  (result: ResponseDeleteTaskManual) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskTargetServiceSetting = async (): Promise<any> => ApiClient.get(
  '/api/task/target_service_settings',
  (result: ResponseGetTaskTargetServiceSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskTargetServiceSetting = async (params: RequestPostTaskTargetServiceSetting): Promise<any> => ApiClient.post(
  '/api/task/target_service_settings',
  (result: ResponsePostTaskTargetServiceSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskTargetServiceSetting = async (params: RequestDeleteTaskTargetServiceSetting): Promise<any> => ApiClient.delete(
  `/api/task/target_service_settings/${params.id}`,
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelMasterSetting = async (params: RequestGetTaskLabelMasterSetting): Promise<any> => ApiClient.get(
  '/api/task/label_master_settings',
  (result: ResponseGetTaskLabelMasterSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskLabelMasterSetting = async (params: RequestPostTaskLabelMasterSetting): Promise<any> => ApiClient.post(
  '/api/task/label_master_settings',
  (result: ResponsePostTaskLabelMasterSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelMasterSetting = async (params: RequestPatchTaskLabelMasterSetting): Promise<any> => ApiClient.patch(
  `/api/task/label_master_settings/${params.label_master_id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskLabelMasterSetting = async (params: RequestDeleteTaskLabelMasterSetting): Promise<any> => ApiClient.delete(
  `/api/task/label_master_settings/${params.label_master_id}`,
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelSetting = async (params: RequestGetTaskLabelSetting): Promise<any> => ApiClient.get(
  '/api/task/label_groups',
  (result: ResponseGetTaskLabelSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelSettingDetail = async (params: RequestGetTaskLabelSettingDetail): Promise<any> => ApiClient.get(
  `/api/task/label_groups/${params.id}`,
  (result: ResponseGetTaskLabelSettingDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelSettingNewDetail = async (): Promise<any> => ApiClient.get(
  "/api/task/label_groups/new",
  (result: ResponseGetTaskLabelSettingNewDetail) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCandidateServices = async (): Promise<any> => ApiClient.get(
  "/api/task/candidate_services",
  (result: ResponseGetTaskCandidateServices) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskLabelSettingLabelGroup = async (params: RequestPostTaskLabelSettingLabelGroup): Promise<any> => ApiClient.post(
  '/api/task/label_groups',
  (result: ResponsePostTaskLabelSettingLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelSettingLabelGroup = async (params: RequestPatchTaskLabelSettingLabelGroup): Promise<any> => ApiClient.patch(
  `/api/task/label_groups/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskLabelSettingLabelGroup = async (params: RequestDeleteTaskLabelSettingLabelGroup): Promise<any> => ApiClient.delete(
  `/api/task/label_groups/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelSettingTeamLabelRelation = async (params: RequestPatchTaskLabelSettingTeamLabelRelation): Promise<any> => ApiClient.patch(
  `/api/task/label_setting/team_label_relation/`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelingStatus = async (params: RequestGetTaskLabelingStatus): Promise<any> => ApiClient.get(
  '/api/task/labeling_status',
  (result: ResponseGetTaskLabelingStatus) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroup = async (params: RequestGetTaskReportLabelGroup): Promise<any> => ApiClient.get(
  '/api/task/report/label_groups',
  (result: ResponseGetTaskReportLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroupDetail = async (params: RequestGetTaskReportLabelGroupDetail): Promise<any> => ApiClient.get(
  `/api/task/report/label_groups/${params.id}`,
  (result: ResponseGetTaskReportLabelGroupDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskReportLabelGroupDetailYearlySummary = async (params: RequestGetTaskReportLabelGroupDetailYearlySummary): Promise<any> => ApiClient.get(
  `/api/task/report/label_groups/${params.label_group_id}/yearly_summary`,
  (result: ResponseGetTaskReportLabelGroupDetailYearlySummary) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroupDetailMax = async (params: RequestGetTaskReportLabelGroupDetailMax): Promise<any> => ApiClient.get(
  `/api/task/report/label_groups/${params.label_group_id}/max`,
  (result: ResponseGetTaskReportLabelGroupDetailMax) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroupDetailSummary = async (params: RequestGetTaskReportLabelGroupDetailSummary): Promise<any> => ApiClient.get(
  `/api/task/report/label_groups/${params.label_group_id}/summary`,
  (result: ResponseGetTaskReportLabelGroupDetailSummary) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskReportLabelGroupDetailSummary = async (params: RequestPatchTaskReportLabelGroupDetailSummary): Promise<any> => ApiClient.patch(
  `/api/task/report/label_groups/${params.label_group_id}/summary`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskServiceRequest = async (params: RequestPostTaskServiceRequest): Promise<any> => ApiClient.post(
  '/api/task/service_request',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskExportList = async (): Promise<any> => ApiClient.get(
  '/api/task/exports',
  (result: ResponseGetTaskExportList) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskExportDetail = async (params: RequestGetTaskExportDetail): Promise<any> => ApiClient.get(
  `/api/task/exports/${params.id}`,
  (result: ResponseGetTaskExportDetail) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskExportDetail = async (params: RequestPostTaskExportDetail): Promise<any> => ApiClient.post(
  `/api/task/exports`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskPermission = async (): Promise<any> => ApiClient.get(
  '/api/task/permission',
  (result: ResponseGetTaskPermission) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskPermission = async (params: RequestPatchTaskPermission): Promise<any> => ApiClient.patch(
  `/api/task/permission`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskMemberCosts = async (): Promise<any> => ApiClient.get(
  '/api/task/member_costs',
  (result: ResponseGetTaskMemberCosts) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskMemberCosts = async (params: RequestPostTaskMemberCosts): Promise<any> => ApiClient.post(
  '/api/task/member_costs',
  (result: ResponsePostTaskMemberCosts) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskMemberCosts = async (params: RequestPatchTaskMemberCosts): Promise<any> => ApiClient.patch(
  `/api/task/member_costs/${params.id}`,
  (result: ResponsePatchTaskMemberCosts) => result,
  { member_costs: params.member_costs },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskSearchNew = async (): Promise<any> => ApiClient.get(
  "/api/task/search/new",
  (result: ResponseGetTaskSearchNew) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskSearch = async (params: RequestGetTaskSearch): Promise<any> => ApiClient.get(
  "/api/task/search",
  (result: ResponseGetTaskSearch) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskSeparate = async (params: RequestPostTaskSeparate): Promise<any> => ApiClient.post(
  '/api/task/separate_tasks',
  (result: ResponsePostTaskSeparate) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskSeparate = async (params: RequestDeleteTaskSeparate): Promise<any> => ApiClient.delete(
  `/api/task/separate_tasks/${params.id}`,
  (result: ResponseDeleteTaskSeparate) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskOverwriteBreakTimeSetting = async (): Promise<any> => ApiClient.get(
  "/api/task/overwrite_break_time_settings",
  (result: ResponseGetTaskOverwriteBreakTimeSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskOverwriteBreakTimeSetting = async (params: RequestPatchTaskOverwriteBreakTimeSetting): Promise<any> => ApiClient.patch(
  "/api/task/overwrite_break_time_settings",
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportMember = async (params: RequestGetTaskReportMember): Promise<any> => ApiClient.get(
  `/api/task/report/members/${params.id}`,
  (result: ResponseGetTaskReportMember) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportTeam = async (params: RequestGetTaskReportTeam): Promise<any> => ApiClient.get(
  `/api/task/report/teams/${params.id}`,
  (result: ResponseGetTaskReportTeam) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskProjectTemplateSetting = async (params: RequestGetTaskProjectTemplateSetting): Promise<any> => ApiClient.get(
  '/api/task/label_group_templates',
  (result: ResponseGetTaskProjectTemplateSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskProjectTemplateSettingDetail = async (params: RequestGetTaskProjectTemplateSettingDetail): Promise<any> => ApiClient.get(
  `/api/task/label_group_templates/${params.id}`,
  (result: ResponseGetTaskProjectTemplateSettingDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskProjectTemplateSetting = async (params: RequestPostTaskProjectTemplateSetting): Promise<any> => ApiClient.post(
  '/api/task/label_group_templates',
  (result: ResponsePostTaskProjectTemplateSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskProjectTemplateSetting = async (params: RequestPatchTaskProjectTemplateSetting): Promise<any> => ApiClient.patch(
  `/api/task/label_group_templates/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskProjectTemplateSetting = async (params: RequestDeleteTaskProjectTemplateSetting): Promise<any> => ApiClient.delete(
  `/api/task/label_group_templates/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskApprovalGroup = async (): Promise<any> => ApiClient.get(
  "/api/task/approval_groups",
  (result: ResponseGetTaskApprovalGroup) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskApprovalGroup = async (params: RequestPostTaskApprovalGroup): Promise<any> => ApiClient.post(
  '/api/task/approval_groups',
  (result: ResponsePostTaskApprovalGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskApprovalGroup = async (params: RequestPatchTaskApprovalGroup): Promise<any> => ApiClient.patch(
  `/api/task/approval_groups/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskApprovalGroup = async (params: RequestDeleteTaskApprovalGroup): Promise<any> => ApiClient.delete(
  `/api/task/approval_groups/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskApprovalApplicationList = async (params: RequestGetTaskApprovalApplicationList): Promise<any> => ApiClient.get(
  "/api/task/approval_applications/member_list",
  (result: ResponseGetTaskApprovalApplicationList) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskApprovalApplication = async (params: RequestGetTaskApprovalApplication): Promise<any> => ApiClient.get(
  "/api/task/approval_applications",
  (result: ResponseGetTaskApprovalApplication) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskApprovalApplicationDetail = async (params: RequestGetTaskApprovalApplicationDetail): Promise<any> => ApiClient.get(
  `/api/task/approval_applications/${params.id}`,
  (result: ResponseGetTaskApprovalApplicationDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskApprovalApplication = async (params: RequestPostTaskApprovalApplication): Promise<any> => ApiClient.post(
  '/api/task/approval_applications',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelGroupCategory = async (): Promise<any> => ApiClient.get(
  "/api/task/label_group_categories",
  (result: ResponseGetTaskLabelGroupCategory) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelGroupCategoryLabelGroup = async (params: RequestGetTaskLabelGroupCategoryLabelGroup): Promise<any> => ApiClient.get(
  `/api/task/label_group_categories/label_groups`,
  (result: ResponseGetTaskLabelGroupCategoryLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskLabelGroupCategory = async (params: RequestPostTaskLabelGroupCategory): Promise<any> => ApiClient.post(
  '/api/task/label_group_categories',
  (result: ResponsePostTaskLabelGroupCategory) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelGroupCategory = async (params: RequestPatchTaskLabelGroupCategory): Promise<any> => ApiClient.patch(
  `/api/task/label_group_categories/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskLabelGroupCategory = async (params: RequestDeleteTaskLabelGroupCategory): Promise<any> => ApiClient.delete(
  `/api/task/label_group_categories/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroupCategory = async (params: RequestGetTaskReportLabelGroupCategory): Promise<any> => ApiClient.get(
  "/api/task/report/label_group_categories",
  (result: ResponseGetTaskReportLabelGroupCategory) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroupCategoryDetail = async (params: RequestGetTaskReportLabelGroupCategoryDetail): Promise<any> => ApiClient.get(
  `/api/task/report/label_group_categories/${params.id}`,
  (result: ResponseGetTaskReportLabelGroupCategoryDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskReportLabelGroupCategoryDetailYearlySummary = async (params: RequestGetTaskReportLabelGroupCategoryDetailYearlySummary): Promise<any> => ApiClient.get(
  `/api/task/report/label_group_categories/${params.label_group_category_id}/yearly_summary`,
  (result: ResponseGetTaskReportLabelGroupCategoryDetailYearlySummary) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskReportLabelGroupCategoryDetailMax = async (params: RequestGetTaskReportLabelGroupCategoryDetailMax): Promise<any> => ApiClient.get(
  `/api/task/report/label_group_categories/${params.label_group_category_id}/max`,
  (result: ResponseGetTaskReportLabelGroupCategoryDetailMax) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskReportLabelGroupCategoryDetailSummary = async (params: RequestGetTaskReportLabelGroupCategoryDetailSummary): Promise<any> => ApiClient.get(
  `/api/task/report/label_group_categories/${params.label_group_category_id}/summary`,
  (result: ResponseGetTaskReportLabelGroupCategoryDetailSummary) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCustomSearchNew = async (): Promise<any> => ApiClient.get(
  "/api/task/custom_search/new",
  (result: ResponseGetTaskCustomSearchNew) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCustomSearch = async (params: RequestGetTaskCustomSearch): Promise<any> => ApiClient.get(
  "/api/task/custom_search",
  (result: ResponseGetTaskCustomSearch) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskGanttChartList = async (params: RequestGetTaskGanttChartList): Promise<any> => ApiClient.get(
  '/api/task/gantt_charts',
  (result: ResponseGetTaskGanttChartList) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskGanttChart = async (params: RequestGetTaskGanttChart): Promise<any> => ApiClient.get(
  `/api/task/gantt_charts/${params.id}`,
  (result: ResponseGetTaskGanttChart) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskGanttChartDetail = async (params: RequestGetTaskGanttChartDetail): Promise<any> => ApiClient.get(
  `/api/task/gantt_chart_detail`,
  (result: ResponseGetTaskGanttChartDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabel = async (params: RequestPatchTaskLabel): Promise<any> => ApiClient.patch(
  `/api/task/labels/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelMember = async (params: RequestPatchTaskLabelMember): Promise<any> => ApiClient.patch(
  `/api/task/labels/${params.label_id}/members/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskExcludeAutoLabelingTask = async (params: RequestPostTaskExcludeAutoLabelingTask): Promise<any> => ApiClient.post(
  '/api/task/exclude_auto_labeling_tasks',
  (result: ResponsePostTaskExcludeAutoLabelingTask) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskExcludeAutoLabelingTask = async (params: RequestDeleteTaskExcludeAutoLabelingTask): Promise<any> => ApiClient.delete(
  `/api/task/exclude_auto_labeling_tasks/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const postTaskLabelMasterImport = async (params: RequestPostTaskLabelMasterImport): Promise<any> => ApiClient.post(
  '/api/task/label_master_imports',
  (result: ResponsePostTaskLabelMasterImport) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelGroupOrder = async (): Promise<any> => ApiClient.get(
  '/api/task/label_group_order',
  (result: ResponseGetTaskLabelGroupOrder) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelGroupOrder = async (params: RequestPatchTaskLabelGroupOrder): Promise<any> => ApiClient.patch(
  '/api/task/label_group_order',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLearningScopeSetting = async (): Promise<any> => ApiClient.get(
  '/api/task/learning_scope_setting',
  (result: ResponseGetTaskLearningScopeSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLearningScopeSetting = async (params: RequestPatchTaskLearningScopeSetting): Promise<any> => ApiClient.patch(
  '/api/task/learning_scope_setting',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelingTargetModeSetting = async (): Promise<any> => ApiClient.get(
  '/api/task/labeling_target_mode_settings',
  (result: ResponseGetTaskLabelingTargetModeSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelingTargetModeSetting = async (params: RequestPatchTaskLabelingTargetModeSetting): Promise<any> => ApiClient.patch(
  '/api/task/labeling_target_mode_settings',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getImportCsv = async (): Promise<any> => ApiClient.getFile(
  '/api/task/label_group_imports',
  (result) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const postTaskLabelGroupImport = async (params: FormData): Promise<any> => ApiClient.postWithMulti(
  '/api/task/label_group_imports',
  (result: ResponsePostTaskLabelGroupImport) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskBulkLabelingNew = async (): Promise<any> => ApiClient.get(
  "/api/task/bulk_labeling/new",
  (result: ResponseGetTaskBulkLabelingNew) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskBulkLabeling = async (params: RequestGetTaskBulkLabeling): Promise<any> => ApiClient.get(
  "/api/task/bulk_labeling",
  (result: ResponseGetTaskBulkLabeling) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const postTaskBulkLabeling = async (params: RequestPostTaskBulkLabeling): Promise<any> => ApiClient.post(
  '/api/task/bulk_labeling',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskBulkLabeling = async (params: RequestDeleteTaskBulkLabeling): Promise<any> => ApiClient.delete(
  `/api/task/bulk_labeling`,
  () => {
    // do nothing
  },
  { data: params },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskNotWorkingRange = async (params: RequestGetTaskNotWorkingRange): Promise<any> => ApiClient.get(
  "/api/task/not_working_range",
  (result: ResponseGetTaskNotWorkingRange) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const patchTaskNotWorkingRange = async (params: RequestPatchTaskNotWorkingRange): Promise<any> => ApiClient.patch(
  '/api/task/not_working_range',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskSearchLabelGroup = async (params: RequestGetTaskSearchLabelGroup): Promise<any> => ApiClient.get(
  "/api/task/search_label_groups",
  (result: ResponseGetTaskSearchLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskRecentlyUsedLabelGroup = async (params: RequestGetTaskRecentlyUsedLabelGroup): Promise<any> => ApiClient.get(
  "/api/task/recently_used_label_groups",
  (result: ResponseGetTaskRecentlyUsedLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelGroupSummary = async (params: RequestGetTaskLabelGroupSummary): Promise<any> => ApiClient.get(
  "/api/task/label_group_summaries",
  (result: ResponseGetTaskLabelGroupSummary) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskViewableLabelGroup = async (params: RequestGetTaskViewableLabelGroup): Promise<any> => ApiClient.get(
  "/api/task/viewable_label_groups",
  (result: ResponseGetTaskViewableLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskViewableLabelGroupDetail = async (params: RequestGetTaskViewableLabelGroupDetail): Promise<any> => ApiClient.get(
  `/api/task/viewable_label_groups/${params.id}`,
  (result: ResponseGetTaskViewableLabelGroupDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskViewableLabelGroupMember = async (params: RequestGetTaskViewableLabelGroupMember): Promise<any> => ApiClient.get(
  "/api/task/viewable_label_groups/members",
  (result: ResponseGetTaskViewableLabelGroupMember) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskViewableLabelGroupTeam = async (params: RequestGetTaskViewableLabelGroupTeam): Promise<any> => ApiClient.get(
  "/api/task/viewable_label_groups/teams",
  (result: ResponseGetTaskViewableLabelGroupTeam) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCreateManualTaskZoneSetting = async (): Promise<any> => ApiClient.get(
  "/api/task/create_manual_task_zone_setting",
  (result: ResponseGetTaskCreateManualTaskZoneSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const patchTaskCreateManualTaskZoneSetting = async (params: RequestPatchTaskCreateManualTaskZoneSetting): Promise<any> => ApiClient.patch(
  "/api/task/create_manual_task_zone_setting",
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCreateTaskByUrlSetting = async (): Promise<any> => ApiClient.get(
  "/api/task/create_task_by_url_setting",
  (result: ResponseGetTaskCreateTaskByUrlSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskCreateTaskByUrlSetting = async (params: RequestPatchTaskCreateTaskByUrlSetting): Promise<any> => ApiClient.patch(
  '/api/task/create_task_by_url_setting',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskThresholdSetting = async (): Promise<any> => ApiClient.get(
  "/api/task/task_threshold_setting",
  (result: ResponseGetTaskThresholdSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskThresholdSetting = async (params: RequestPatchTaskThresholdSetting): Promise<any> => ApiClient.patch(
  "/api/task/task_threshold_setting",
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskDisableTaskCreationSetting = async (): Promise<any> => ApiClient.get(
  "/api/task/exclude_task_generate_member_setting",
  (result: ResponseGetTaskDisableTaskCreationSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskDisableTaskCreationSetting = async (params: RequestPatchTaskDisableTaskCreationSetting): Promise<any> => ApiClient.patch(
  '/api/task/exclude_task_generate_member_setting',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskOnlineMeetingSetting = async (): Promise<any> => ApiClient.get(
  "/api/task/create_online_meeting_task_setting",
  (result: ResponseGetTaskOnlineMeetingSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskOnlineMeetingSetting = async (params: RequestPatchTaskOnlineMeetingSetting): Promise<any> => ApiClient.patch(
  '/api/task/create_online_meeting_task_setting',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelingConditions = async (params: RequestGetTaskLabelingConditions): Promise<any> => ApiClient.get(
  '/api/task/labeling_conditions',
  (result: ResponseGetTaskLabelingConditions) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelingConditionNew = async (params: RequestGetTaskLabelingConditionNew): Promise<any> => ApiClient.get(
  '/api/task/labeling_conditions/new',
  (result: ResponseGetTaskLabelingConditionNew) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskMemberLabelingConditionNew = async (params: RequestGetTaskMemberLabelingConditionNew): Promise<any> => ApiClient.get(
  '/api/task/member_labeling_conditions/new',
  (result: ResponseGetTaskMemberLabelingConditionNew) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskMemberLabelingConditions = async (params: RequestGetTaskMemberLabelingConditions): Promise<any> => ApiClient.get(
  '/api/task/member_labeling_conditions',
  (result: ResponseGetTaskMemberLabelingConditions) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskLabelingCondition = async (params: RequestPostTaskLabelingCondition): Promise<any> => ApiClient.post(
  '/api/task/labeling_conditions',
  (result: ResponsePostTaskLabelingCondition) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskMemberLabelingCondition = async (params: RequestPostTaskMemberLabelingCondition): Promise<any> => ApiClient.post(
  '/api/task/member_labeling_conditions',
  (result: ResponsePostTaskMemberLabelingCondition) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelingCondition = async (params: RequestPatchTaskLabelingCondition): Promise<any> => ApiClient.patch(
  `/api/task/labeling_conditions/${params.id}`,
  (result: ResponsePatchTaskLabelingCondition) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskMemberLabelingCondition = async (params: RequestPatchTaskMemberLabelingCondition): Promise<any> => ApiClient.patch(
  `/api/task/member_labeling_conditions/${params.id}`,
  (result: ResponsePatchTaskMemberLabelingCondition) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskLabelingCondition = async (params: RequestDeleteTaskLabelingCondition): Promise<any> => ApiClient.delete(
  `/api/task/labeling_conditions/${params.id}`,
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskMemberLabelingCondition = async (params: RequestDeleteTaskMemberLabelingCondition): Promise<any> => ApiClient.delete(
  `/api/task/member_labeling_conditions/${params.id}`,
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCompanyServiceGroup = async (): Promise<any> => ApiClient.get(
  '/api/setting/company_service_group',
  (result: ResponseGetTaskCompanyServiceGroup) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCompanyServiceGroupDetail = async (params: RequestGetTaskCompanyServiceGroupDetail): Promise<any> => ApiClient.get(
  '/api/setting/company_service_group/edit',
  (result: ResponseGetTaskCompanyServiceGroupDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskCompanyServiceGroup = async (params: RequestPostTaskCompanyServiceGroup): Promise<any> => ApiClient.post(
  '/api/setting/company_service_group',
  (result: ResponsePostTaskCompanyServiceGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskCompanyServiceGroup = async (params: RequestPatchTaskCompanyServiceGroup): Promise<any> => ApiClient.patch(
  '/api/setting/company_service_group',
  () => {
    // do nothing
  },
  params,
)
